import React from 'react'
import loader from '../../../assets/gifs/formalooLoader.gif'
import { CircularProgress } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import Spinner from 'react-spinkit'
import './loading.css'

export const Loading = () => (
  <div
    className="customised-spinner-wrapper"
    style={{
      minHeight: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      zIndex: 99999,
      display: 'block !important',
    }}
  >
    <Spinner name="wordpress" fadeIn="none" color="orange" />
  </div>
)

export const ButtonSpinner = ({
  minHeight = 20,
  size = 17,
  color = 'primary',
}) => (
  <div
    style={{
      width: '100%',
      height: minHeight,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CircularProgress size={size} color={color} />
  </div>
)

const CustomiseLoader = ({ minHeight = '100vh' }) => (
  <div
    className="customised-spinner-wrapper"
    style={{
      minHeight,
    }}
  >
    <img src={loader} alt="formaloo" style={{ width: '100px' }} />
    <p>
      <FormattedMessage id="formaloo.loader" />
    </p>
  </div>
)

export default CustomiseLoader
